const { getOffsetTop } = window.BAO.Utils

class ParallaxElement extends window.BAO.CustomElement() {
  connectedCallback () {
    /* eslint-disable-next-line no-undef */
    if (Shopify.designMode) return

    super.connectedCallback()

    const prefersReducedMotion = window.matchMedia(
      '(prefers-reduced-motion: reduce)',
    ).matches

    if (prefersReducedMotion) return
    if (!window.BAO.MediaBreakpoints.isSm) return

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.cachedScrollPositions = null

    this.updateEl()

    window.setTimeout(() => {
      this.setAttribute('active', '')
    }, 500)
  }

  setupListeners () {
    super.setupListeners()

    if (!window.BAO.MediaBreakpoints.isSm) return

    this.onScroll = this.onScroll.bind(this)

    this.debouncedOnResize = window.BAO.Utils.debounce(() => {
      this.cachedScrollPositions = null
    }, 200)

    window.addEventListener('scroll', this.onScroll, { passive: true })
    window.addEventListener('resize', this.debouncedOnResize)
  }

  onScroll () {
    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveParallaxItem()
  }

  moveParallaxItem () {
    if (!this.offsetHeight) return

    const directionModifier = this.reverseDirection ? -1 : 1

    const amountToMoveY = window.BAO.MediaBreakpoints.isXsViewport
      ? this.mobileDistance * directionModifier
      : this.desktopDistance * directionModifier

    const elementHeight = this.offsetHeight

    const scaledItemHeight = elementHeight + amountToMoveY
    const heightDifference = scaledItemHeight - elementHeight

    if (!this.cachedScrollPositions) {
      const offsetTop = getOffsetTop(this)

      this.cachedScrollPositions = {
        start: offsetTop - window.innerHeight,
        end: offsetTop + elementHeight,
      }
    }

    const elementStartPoint = this.cachedScrollPositions.start
    const elementEndPoint = this.cachedScrollPositions.end

    if (this.lastKnownY <= elementStartPoint) {
      this.style.transform = `translate3d(0px, ${amountToMoveY / -2}px, 0px)`

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.transform = `translate3d(0px, ${amountToMoveY / 2}px, 0px)`

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const transformAmountY =
      heightDifference * scrollYAsAPercentageOfJourney -
      (heightDifference / 2) * directionModifier

    this.style.transform = `translate3d(0px, ${transformAmountY}px, 0px)`
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.removeEventListener('scroll', this.onScroll)
    window.removeEventListener('resize', this.debouncedOnResize)

    this.cachedScrollPositions = null
  }

  get desktopDistance () {
    const distance = this.dataset.desktopDistance
    return isNaN(distance) ? 60 : Number(distance)
  }

  get reverseDirection () {
    return this.dataset.reverseDirection === 'true'
  }
}

if (!customElements.get('parallax-element')) {
  customElements.define('parallax-element', ParallaxElement)
}
